import { setStore, getStore, removeStore } from '@/lib/localStore';
import { rootStore } from '../store/rootStore';
export const TokenKey = 'LINGHIT_UNIFY_BACKEND_TOKEN_V2';

export function getToken() {
  const token = getStore({
    name: TokenKey,
  });

  const store = rootStore();
  store.setLoginFlag(!!token);
  return token;
}

export function setToken(token) {
  return setStore({
    name: TokenKey,
    content: token,
    options: {
      expiry: '14h',
      create: new Date().getTime(),
    },
  });
}

export function removeToken() {
  return removeStore({
    name: TokenKey,
  });
}
